export default {
  dayMonthYear: 'DD/MM/YY',
  short: 'Do MMMM',
  long: 'D MMMM YYYY',
  cards: 'MMMM YYYY',
  cardInput: 'MM YYYY',
};
